import React from 'react';
import { string } from 'prop-types';
import { Button } from '@chaser/components';
import useModal from '../../hooks/useModal';
import SupportModal from '../SupportModal';
import styles from './RemoteUnavailable.module.scss';

const WarningIcon = () => (
  <svg className={styles.icon} viewBox="0 0 72 72" fill="none" aria-hidden="true">
    <circle className={styles.iconHalo} cx="36" cy="36" r="36" />
    <path
      className={styles.iconBadge}
      d="M24.3 16h23.4L56 24.3v23.4L47.7 56H24.3L16 47.7V24.3L24.3 16z"
    />
    <path d="M36 26v14" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" />
    <circle cx="36" cy="46.5" r="2.25" fill="#fff" />
  </svg>
);

const RemoteUnavailable = ({ errorCode }) => {
  const showModal = useModal();

  const handleContactSupport = () => {
    showModal(
      <SupportModal
        initialSubject={`This page is temporarily unavailable (${errorCode})`}
      />,
    );
  };

  return (
    <div className={styles.page} role="alert">
      <div className={styles.inner}>
        <WarningIcon />
        <h1 className={styles.heading}>This page is temporarily unavailable</h1>
        <p className={styles.body}>
          We&apos;re experiencing an issue loading this page. This usually resolves within a few
          minutes.
        </p>
        <Button className={styles.tryAgain} onClick={() => window.location.reload()}>
          Try again
        </Button>
        <button type="button" className={styles.support} onClick={handleContactSupport}>
          Contact support
        </button>
        <p className={styles.footer}>
          Error code: {errorCode} · Last checked: just now
        </p>
      </div>
    </div>
  );
};

RemoteUnavailable.propTypes = {
  errorCode: string.isRequired,
};

export default RemoteUnavailable;
